export const PAGE_SIZE = 10;

export function formatDate(iso) {
  if (iso == null || iso === '') return '—';
  try {
    const date = typeof iso === 'number' ? new Date(iso) : new Date(iso);
    if (!Number.isFinite(date.getTime())) return '—';
    return date.toLocaleString('en-US', { 
  hour12: true 
});
  } catch {
    return '—';
  }
}
